import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * Initializes Post Content Sliders.
 */
export const initPostSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>("[data-post-slider]");

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderContainer) => {
    const swiperElement = sliderContainer.querySelector<HTMLElement>(".swiper");
    if (!swiperElement) return;

    new Swiper(swiperElement, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: sliderContainer.querySelector(".swiper-pagination") as HTMLElement,
        clickable: true,
      },
      navigation: {
        nextEl: sliderContainer.querySelector(
          ".swiper-button-next"
        ) as HTMLElement,
        prevEl: sliderContainer.querySelector(
          ".swiper-button-prev"
        ) as HTMLElement,
      },
    });
  });

  console.log("[Post Slider] Initialized.");
};
